

















































































import {Component, Watch, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import PlanSearchDialog from './PlanSearchDialog.vue';
import ScheduleSearchDialog from '@/views/journals/ScheduleSearchDialog.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CSearch from '@/components/base/search/CSearch.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField, CSearch, CSelect, CTextField, CEditDialog},
})
export default class PlanDialog extends Mixins(EditDialogMixin) {
    private planSearchDialog = PlanSearchDialog;
    private scheduleSearchDialog = ScheduleSearchDialog;

    get availableCalculationTypes() {
        if (!this.data) return [];
        const result: any[] = [];
        this.data.Config.PlanOrderVariations.forEach((item: any) => {
            result.push(item.IdCalculationType);
        });
        return Array.from(new Set(result));
    }

    get availablePlanOrderTypes() {
        if (!this.data) return [];
        const result: any[] = [];
        this.data.Config.PlanOrderVariations.forEach((item: any) => {
            if (item.IdCalculationType === this.data.Item.IdCalculationType) result.push(item.IdPlanOrderType);
        });
        return Array.from(new Set(result));
    }

    get availablePlanPriorityOrderTypes() {
        if (!this.data) return [];
        const result: any[] = [];
        this.data.Config.PlanOrderVariations.forEach((item: any) => {
            if (
                item.IdCalculationType === this.data.Item.IdCalculationType &&
                item.IdPlanOrderType === this.data.Item.IdPlanOrderType
            )
                result.push(item.IdPlanPriorityOrderType);
        });
        return Array.from(new Set(result));
    }

    @Watch('availableCalculationTypes', {deep: true})
    onAvailableCalculationTypesChange(value: any) {
        if (!this.data) return;
        if (value.findIndex((tmp: any) => tmp === this.data.Item.IdCalculationType) === -1)
            this.data.Item.IdCalculationType = value[0];
    }

    @Watch('availablePlanOrderTypes', {deep: true})
    onAvailablePlanOrderTypesChange(value: any) {
        if (!this.data) return;
        if (
            this.data.Item.IdPlanOrderType != null &&
            value.findIndex((tmp: any) => tmp === this.data.Item.IdPlanOrderType) != -1
        )
            return;
        this.data.Item.IdPlanOrderType = value[0];
    }

    @Watch('availablePlanPriorityOrderTypes', {deep: true})
    onAvailablePlanPriorityOrderTypesChange(value: any) {
        if (!this.data) return;
        if (
            this.data.Item.IdPlanPriorityOrderType != null &&
            value.findIndex((tmp: any) => tmp === this.data.Item.IdPlanPriorityOrderType) != -1
        )
            return;
        this.data.Item.IdPlanPriorityOrderType = value[0];
    }
}
